var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarExample(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D4C2E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5616 35.0002L28.5816 27.9502C31.5216 26.9002 33.2016 24.5602 33.2016 21.3202C33.2016 16.7602 29.9016 14.0002 24.4416 14.0002H16.2516V35.0002H19.2516V28.6102H24.4416C24.8916 28.6102 25.3416 28.5802 25.7616 28.5502L30.2916 35.0002H33.5616ZM24.3516 26.0602H19.2516V16.6102H24.3516C28.1916 16.6102 30.2016 18.3202 30.2016 21.3202C30.2016 24.3202 28.1916 26.0602 24.3516 26.0602Z",
    fill: "#40008E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarExample);
export default __webpack_public_path__ + "static/media/avatar-example.b2076e9916df27f126715b3ab7f956a7.svg";
export { ForwardRef as ReactComponent };